import Vue from 'vue';
import Component from 'vue-class-component';
import Organization from '@/tools/models/organization.model';
import EdListInactiveClassesComponent from '@/classes/components/ed-list-inactive-classes/ed-list-inactive-classes.component.vue';

@Component({
  components: {
    EdListInactiveClasses: EdListInactiveClassesComponent,
  }
})
export default class EdClassInactiveView extends Vue {

  public organization: Organization = new Organization;
  public departmentId: number;
  public organizationId: number;

  returnToAdmin() {
    this.$router.push({ name: 'class-admin' });
  }
 
    /* Hooks */
    created() {
      this.organization = this.$store.state.ToolsStore.institutionInfo[0];
      this.organizationId = this.organization['organizationId']
      this.departmentId = Number(this.$route.params.departmentId);

    }

}